import React from 'react';
import '../styles/CustomerSupport.css';

const CustomerSupport = () => {
  // 환경 변수에서 관리자 연락처 정보 가져오기
  const adminPhone = process.env.REACT_APP_ADMIN_PHONE_NUMBER || '010-2349-4208';
  const adminEmail = process.env.REACT_APP_ADMIN_EMAIL || 'tapgo0505@gmail.com';
  const companyName = process.env.REACT_APP_ADMIN_COMPANY_NAME || '탭고';
  const adminName = process.env.REACT_APP_ADMIN_NAME || '김예훈';
  const businessNumber = process.env.REACT_APP_ADMIN_BUSINESS_NUMBER || '635-11-02678';
  const salesNumber = process.env.REACT_APP_ADMIN_SALES_NUMBER || '-';
  const address = process.env.REACT_APP_ADMIN_ADDRESS || '서울특별시 서대문구 이화여대8길 123, 112동 404호';

  return (
    <div className="customerSupportContainer">
      <h1 className="pageTitle">고객지원</h1>
      
      <div className="contactInfoContainer">
        <div className="contactCard">
          <div className="contactInfo">
            <div className="contactItem">
              <span className="contactLabel">상호명:</span>
              <span className="contactValue">{companyName}</span>
            </div>
            <div className="contactItem">
              <span className="contactLabel">대표자명:</span>
              <span className="contactValue">{adminName}</span>
            </div>
            <div className="contactItem">
              <span className="contactLabel">사업자등록번호:</span>
              <span className="contactValue">{businessNumber}</span>
            </div>
            <div className="contactItem">
              <span className="contactLabel">통신판매업신고번호:</span>
              <span className="contactValue">{salesNumber}</span>
            </div>
            <div className="contactItem">
              <span className="contactLabel">사업장주소:</span>
              <span className="contactValue">{address}</span>
            </div>
            <div className="contactItem">
              <span className="contactLabel">유선전화번호:</span>
              <span className="contactValue">{adminPhone}</span>
            </div>
            <div className="contactItem">
              <span className="contactLabel">이메일:</span>
              <span className="contactValue">{adminEmail}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerSupport; 